import types from '../types';

const referrals = (
  state = {
    data: null,
    export: {
      excel: null,
      xml: null,
    },
    referals_statistics: null,
    user_referral_list: null,
    user_referral_bonuses: null,
    loading: true,
  },
  { type, payload },
) => {
  switch (type) {
    case types.GET_REFERRALS_START:
    case types.GET_REFERRALS_STATISTICS_START:
    case types.GET_USER_LIST_OF_REFERRALS_START:
    case types.GET_USER_REFERRALS_BONUSES_START:
    case types.GET_REFERRALS_EXCEL_START:
    case types.GET_REFERRALS_XML_START:
      return { ...state, loading: true };

    case types.GET_REFERRALS_SUCCESS:
      return { ...state, data: payload, loading: false };

    case types.GET_REFERRALS_STATISTICS_SUCCESS:
      return { ...state, referals_statistics: payload, loading: false };

    case types.GET_USER_LIST_OF_REFERRALS_SUCCESS:
      return { ...state, user_referral_list: payload, loading: false };

    case types.GET_USER_REFERRALS_BONUSES_SUCCESS:
      return { ...state, user_referral_bonuses: payload, loading: false };

    case types.GET_REFERRALS_EXCEL_SUCCESS:
      return {
        ...state,
        export: { ...state.export, excel: payload },
        loading: false,
      };

    case types.GET_REFERRALS_XML_SUCCESS:
      return { ...state, export: { ...state.export, xml: payload }, loading: false };

    case types.GET_REFERRALS_FAILURE:
    case types.GET_REFERRALS_STATISTICS_FAILURE:
    case types.GET_USER_LIST_OF_REFERRALS_FAILURE:
    case types.GET_USER_REFERRALS_BONUSES_FAILURE:
    case types.GET_REFERRALS_EXCEL_FAILURE:
    case types.GET_REFERRALS_XML_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default referrals;
